import { render, staticRenderFns } from "./AddDoctorAppointmentModal.vue?vue&type=template&id=37193854&"
import script from "./AddDoctorAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./AddDoctorAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDoctorAppointmentModal.vue?vue&type=style&index=0&id=37193854&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports